import { render, staticRenderFns } from "./VMyCases.vue?vue&type=template&id=498c1c54&"
import script from "./VMyCases.vue?vue&type=script&lang=js&"
export * from "./VMyCases.vue?vue&type=script&lang=js&"
import style0 from "./VMyCases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports